import React from 'react';
import { Card } from './ui/card';
import { 
  Video, 
  FileQuestion, 
  Award, 
  Clock, 
  Smartphone, 
  RefreshCw,
  Users,
  MessageCircle,
  Download
} from 'lucide-react';

const features = [
  {
    icon: Video,
    title: "40+ Hours of Content",
    description: "Comprehensive video lessons covering all OSHA requirements",
    color: "bg-blue-500"
  },
  {
    icon: FileQuestion,
    title: "Interactive Quizzes",
    description: "Test your knowledge with quizzes after each module",
    color: "bg-purple-500"
  },
  {
    icon: Award,
    title: "Certificate of Completion",
    description: "Earn a verifiable certificate upon finishing",
    color: "bg-emerald-500"
  },
  {
    icon: Clock,
    title: "Self-Paced Learning",
    description: "Learn at your own speed, anytime, anywhere",
    color: "bg-amber-500"
  },
  {
    icon: Smartphone,
    title: "Mobile Friendly",
    description: "Access on any device - desktop, tablet, or phone",
    color: "bg-pink-500"
  },
  {
    icon: RefreshCw,
    title: "Lifetime Updates",
    description: "Get free updates as OSHA regulations change",
    color: "bg-cyan-500"
  },
  {
    icon: Users,
    title: "Real-World Scenarios",
    description: "Practice with interactive workplace situations",
    color: "bg-orange-500"
  },
  {
    icon: MessageCircle,
    title: "Expert Support",
    description: "Get help from safety professionals when needed",
    color: "bg-indigo-500"
  },
  {
    icon: Download,
    title: "Downloadable Resources",
    description: "Checklists, templates, and reference guides",
    color: "bg-rose-500"
  }
];

const CourseFeatures = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">Everything Included</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-4">
            Course Features
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Get access to comprehensive safety training with all the tools you need to succeed
          </p>
        </div>

        {/* Features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className="p-6 bg-white border border-slate-200 rounded-xl hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 rounded-xl ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <feature.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">{feature.title}</h3>
              <p className="text-slate-600 text-sm">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseFeatures;
